/**
 * Date Input Renderer
 *
 * Native HTML5 date input field
 */

import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import type { FieldRenderer } from '@/MyCode/core';

/**
 * Date Input Renderer
 * Features:
 * - Native date picker
 * - Min/max date constraints
 * - Error states
 * - Accessibility support
 */
export const renderDateInput: FieldRenderer = ({
    field,
    value,
    hasError,
    handleChange,
    isRequired
}) => {
    return (
        <div className="space-y-2">
            <Label htmlFor={field.name}>
                {field.label}
                {isRequired && <span className="text-destructive ml-1">*</span>}
            </Label>
            <Input
                id={field.name}
                type="date"
                value={value || ''}
                onChange={(e) => handleChange(field.name, e.target.value)}
                min={field.minValue as string}
                max={field.maxValue as string}
                className={hasError ? 'border-destructive' : ''}
            />
            {hasError && (
                <p className="text-sm text-destructive">
                    {/* Error message would be displayed here */}
                </p>
            )}
        </div>
    );
};

export default renderDateInput;
